import { render, staticRenderFns } from "./home_help.vue?vue&type=template&id=69c2414c&scoped=true&"
import script from "./home_help.vue?vue&type=script&lang=js&"
export * from "./home_help.vue?vue&type=script&lang=js&"
import style0 from "./home_help.vue?vue&type=style&index=0&id=69c2414c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c2414c",
  null
  
)

export default component.exports